import { render } from "./homeworkManager.vue?vue&type=template&id=406c5087"
import script from "./homeworkManager.vue?vue&type=script&lang=js"
export * from "./homeworkManager.vue?vue&type=script&lang=js"

import "./homeworkManager.vue?vue&type=style&index=0&id=406c5087&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__